import moment from "moment-timezone";

export const isDate = (input: string | Date): boolean => {
  return moment(input).isValid();
};

export const dateToLocaleMDDYYYY = (input: string | Date) => {
  try {
    if (!isDate(input)) {
      return "!#N/A";
    }

    return moment(input).format("LL"); // e.g., "June 30, 2025"
  } catch (error) {
    console.error("dateToLocaleMDDYYYY error:", error);
    return "!#N/A";
  }
};
